import React,{useContext, useState} from 'react';
import { useHistory } from "react-router-dom";

import Modal from '../../../modal/Modal';
import {ContextPlayer} from '../../player/PlayerProvider';
import {getRankingPosition} from '../../../store/storeRanking';
import {parseTimeToString} from '../../../Utils';

import  Piii from 'piii';
import PiiiFilters from 'piii-filters';

import Warning from './warning/Warning';

import './ModalWin.css';

const ModalWin = ({visible}) => {

    const {state, dispatch} = useContext(ContextPlayer);
    const [war, setWar] = useState(false);

    let history = useHistory();
    
    const piii = new Piii({
        filters: [
          [...Object.values(PiiiFilters)]
        ],
        aliases: {
          a: ["2", "4", "@"],
          e: ["3", "&"],
          o: ["0",'u'],
          i: ['1','|','l']
        }
      });
  

    const handleSalvar = () => {
        const playerName = document.getElementById("namePlayer").value || "Desconhecido";
        
        if(!piii.has(playerName)){
            dispatch({type:"UpdateData", name:playerName});
            history.push('/rank');
        }else{
            setWar(true);
        }
    };

    const handleWarning = () => {
        setWar(!war);
    }

    return(
        <Modal visible = {visible}>
            <div className="modalWin column nowrap centerItens centerText colorEIC2 shadow">
                <img className="trophy" src="/app/infocovidturbo/images/layout/win/trophy.png" alt="Troféu"/>
                <span className="title">Parabéns</span>
                <span className="content">
                    Você terminou o jogo em {parseTimeToString(state.timeout)} <br/>e ficou {getRankingPosition(state)+1}º lugar.
                </span>
                <span className="titleButton">Salve sua conquista <br/> Digite o seu nome</span>
                <input id="namePlayer" type="text" maxLength={12} className="input centerText"/>
                
                <button className="button shadow" onClick={handleSalvar}>Salvar</button>
                <Warning handler = {handleWarning} visible = {war}/>   
            </div>
        </Modal>
    );
};

export default ModalWin;